import { getListReviewProject } from "@/api/endpoint/reviews/get-list-review-project";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import { useRouter } from "next/router";
import { ReactNode, useCallback, useContext, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { skipNullParams } from "@/utils";
import ReviewItem from "./ReviewItem";
import EmptyReviewList from "./ReviewItem/EmptyReviewList";
import { getReviewsReactions } from "@/api/endpoint/reviews/get-reviews-reactions";
import BoxReview from "@/modules/Desktop/ProjectDetail/BoxReview";
import clsx from "clsx";
import ReportModal from "./ReviewItem/ReportModal";

const ListReview = ({ reviewFilter }: { reviewFilter: ReactNode }) => {
  const {
    projectListVote,
    setProjectListVote,
    project,
    listReviewsIds,
    setListReviewIds,
    listReviewReactions,
    setListReviewReactions,
  } = useContext(ProjectContext);
  const { userDataHeader } = useAuth();

  const {
    query: { reviewId, voteScore, type, haveMedia, comment },
  } = useRouter();

  const handleGetListReviewsReactions = async () => {
    const res = await getReviewsReactions(listReviewsIds, userDataHeader);
    if (res) {
      setListReviewReactions([...listReviewReactions, ...res]);
    }
  };

  useEffect(() => {
    if (listReviewsIds?.length) {
      handleGetListReviewsReactions();
    }
  }, [listReviewsIds]);

  const onLoadMore = async () => {
    // getListProjectReview();
    const res = await getListReviewProject(
      project._id,
      skipNullParams({
        page: projectListVote.page + 1,
        sort: "publishedAt:desc",
        voteScore: voteScore ? Number(`${voteScore}`) : null,
        type: type ? Number(`${type}`) : null,
        haveMedia: haveMedia ? Boolean(`${haveMedia}`) : null,
        comment: comment,
      }),
      userDataHeader
    );
    if (res) {
      let listIds = [];
      res?.results?.map((item) => {
        listIds.push(item?._id);
        if (item.replies?.length) {
          item.replies.map((rep) => {
            listIds.push(rep._id);
          });
        }
      });
      setListReviewIds(listIds);
    }
    setProjectListVote({
      ...res,
      results: [...projectListVote.results, ...res.results],
    });
  };

  useEffect(() => {
    if (reviewId) {
      const element = document.getElementById(`${reviewId}`);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [reviewId]);

  const handleSyncReaction = useCallback(async () => {
    if (userDataHeader) {
      const syncData = await getListReviewProject(
        project._id,
        skipNullParams({
          sort: "publishedAt:desc",
          voteScore: voteScore ? Number(`${voteScore}`) : null,
          type: type ? Number(`${type}`) : null,
          haveMedia: haveMedia ? Boolean(`${haveMedia}`) : null,
          comment: comment,
        }),
        userDataHeader
      );
      setProjectListVote(syncData);
    }
  }, [
    comment,
    haveMedia,
    project._id,
    setProjectListVote,
    type,
    userDataHeader,
    voteScore,
  ]);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (!projectListVote) handleSyncReaction();
  }, [handleSyncReaction, projectListVote]);
  useEffect(() => {
    setMounted(true);
  }, []);
  return (
    <div
      className={clsx(
        "overflow-auto flex-[1_1_auto] ",
        projectListVote?.totalResults ? "bg-grey-50" : "bg-white md:bg-grey-50"
      )}>
      {/* <DetailModalPreviewFile /> */}
      {reviewFilter}

      {projectListVote?.totalResults ? (
        <>
          <BoxReview />
          <InfiniteScroll
            dataLength={projectListVote?.results?.length || 0}
            next={onLoadMore}
            hasMore={
              projectListVote?.results?.length < projectListVote?.totalResults
            }
            className=" flex-[1_1_auto] flex flex-col md:gap-4 gap-1  overflow-auto w-full"
            loader={
              <div className="px-4 flex items-center justify-center">
                <div className="dot-flashing" />
              </div>
            }>
            {/* <div className=" bg-grey-100 flex flex-col gap-5 overflow-auto w-full"> */}
            {projectListVote.results?.map((item, index) => {
              return (
                <ReviewItem
                  data={item}
                  key={item._id}
                  itemIndex={index}
                  mounted={mounted}
                />
              );
            })}
            {/* </div> */}
          </InfiniteScroll>
          <ReportModal />
        </>
      ) : (
        <EmptyReviewList />
      )}
    </div>
  );
};

export default ListReview;
